/**
 * Interrupteur du feedback en direct pendant l'appel (« sideband ») — décision de Valérie du
 * 13/10/2026 : la fonctionnalité n'est pas terminée, elle part en production et en démo sans y
 * être montrée. Ouverte seulement quand `SIDEBAND_ENABLED` vaut « true » (dev, staging) — pour
 * tout le monde, ADM compris : il n'y a rien à vérifier en prod tant que le contrôleur n'y est pas.
 *
 * Serveur : `POST /api/sideband` ne relaie rien et ne journalise aucune erreur ; le flux
 * `…/live-event/:id/stream` répond 404. Écran : ni panneau de barres, ni relais, ni flux.
 */
export const VARIABLE_SIDEBAND = "SIDEBAND_ENABLED";

export function sidebandInterrupteurActif(env: Record<string, string | undefined> = process.env): boolean {
  return env[VARIABLE_SIDEBAND] === "true";
}

// ── Store écran (fermé tant qu'on ne sait pas) ──
let visible = false;
const abonnes = new Set<() => void>();
export function setSidebandVisible(v: boolean): void {
  if (v === visible) return;
  visible = v;
  for (const f of abonnes) f();
}
export function isSidebandVisible(): boolean {
  return visible;
}
export function subscribeSidebandVisible(f: () => void): () => void {
  abonnes.add(f);
  return () => abonnes.delete(f);
}
